import React from 'react'
import { isEmpty } from 'lodash'
import { Card, Row, Col } from 'reactstrap'
import { getImagesOfProduct } from '../../../helpers/utils'
import ProductCard from '../ProductCard'

const TopProducts = ({
  products,
  goTo,
  action,
}) => {
  return (
    <Card>
      {!isEmpty(products) && (
        <div className="d-flex mt-4" style={{ placeContent: 'space-between' }}>
          <h6 style={{ alignSelf: 'center' }}>Top los más vendidos</h6>
          <div>
            <button
              onClick={goTo}
              className={`btn btn-secondary`}
              style={{ borderRadius: '10px' }}
            >
              Ver más
            </button>
          </div>
        </div>
      )}
      <Row>
        {!isEmpty(products) && products.map(
          (item, key) => (
            <Col key={key} sm={3} style={{ textAlign: 'center', marginBottom: '15px' }}>
              <ProductCard
                photos={getImagesOfProduct(item.gallery)}
                code={`${item.supplierCode ? `Código ${item.supplierCode}` : ''}`}
                price={`${item.wholeSalePrice || 0}`}
                productName={item.name}
                showVariants={false}
                showFooterOptions
                itemAction={() => action(item)}
              />
            </Col>
          )
        )}
      </Row>
    </Card>
  )
}

export default TopProducts
